<script>
import { mapState, mapActions } from 'vuex'
import { confirmaSenha } from '@/api/auth'

export default {
  data () {
    return { email: '', senha: '' }
  },
  computed: {
    ...mapState({
      modalConfirmar: state => state.auth.confirmaSenha
    })
  },
  methods: {
    ...mapActions({
      okConfirmaSenha: 'auth/okConfirmaSenha',
      closeConfirmaSenha: 'auth/closeConfirmaSenha',
      toaster: 'modal/toaster'
    }),
    async continuar () {
      try {
        let token = await confirmaSenha({ email: this.email, senha: this.senha, acesso: this.modalConfirmar.acesso })
        this.email = ''
        this.senha = ''
        return this.okConfirmaSenha(token)
      } catch (e) {
        this.toaster({ message: e.message, color: 'error' })
      }
    },
    fechar () {
      this.senha = ''
      this.closeConfirmaSenha()
    }
  }
}
</script>

<template>
  <v-dialog v-model="modalConfirmar.estado" @input="v => v || fechar()" width="450">
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Confirma Senha
      </v-card-title>
      <v-card-text>
        <form @submit.prevent="continuar">
          <b-field label="Email">
            <b-input
              ref='email'
              v-model="email"
              type="email"
              :value="email"
              placeholder="Digite seu e-mail"
              required>
            </b-input>
          </b-field>
          <b-field label="Senha" class="text-left">
            <b-input
              ref='senha'
              v-model="senha"
              type="password"
              :value="senha"
              password-reveal
              placeholder="Digite sua senha"
              required>
            </b-input>
          </b-field>
          <v-btn @click="continuar" color="primary"> Continuar </v-btn>
          <v-btn @click="fechar"> Cancelar </v-btn>
        </form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style>
  .primary {
    background-color: #2a2f50 !important;
    border-color: #2a2f50 !important;
  }
</style>
